import { DnDStageMapping } from '@forwardflow/features'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { IStageMapGroup } from '@forwardflow/types/onboarding'

export const DnDStageMappingOnboarding = () => {
   const { onboardingData, getNextStep, getPreviousStep, setStageMappings } =
      useOnboardingStoreV2()

   return (
      <DnDStageMapping
         initialStageMappingGroups={onboardingData?.stageMappings}
         onPreviousStep={() => getPreviousStep()}
         onNextStep={() => getNextStep()}
         onSaveStageMappingGroups={(stageMappingGroups) => {
            setStageMappings(stageMappingGroups as IStageMapGroup[])
         }}
      />
   )
}
